/* VEORVO — extras du panier tiroir Dawn : minuteur de réservation, interrupteur « protection du colis », produits à ajouter. */
(function () {
  if (window.VVCart) return;
  window.VVCart = true;

  /* Minuteur : échéance gardée en sessionStorage pour ne pas repartir de zéro à chaque page ou re-rendu du tiroir. */
  if (!customElements.get('vv-cart-timer')) {
    customElements.define('vv-cart-timer', class extends HTMLElement {
      connectedCallback() {
        this.out = this.querySelector('[data-vv-timer]');
        this.ms = (parseInt(this.dataset.minutes, 10) || 5) * 60000;
        this.tick();
        this.iv = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.iv); }
      deadline() {
        let end = 0;
        try { end = parseInt(sessionStorage.getItem('vv-cart-timer'), 10) || 0; } catch (e) {}
        if (end < Date.now()) {
          end = Date.now() + this.ms;
          try { sessionStorage.setItem('vv-cart-timer', String(end)); } catch (e) {}
        }
        return end;
      }
      tick() {
        const left = Math.max(0, this.deadline() - Date.now());
        const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        if (this.out) this.out.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
    });
  }

  /* Rafraîchit le tiroir de Dawn et la bulle du panier. */
  function refresh() {
    const items = document.querySelector('cart-drawer-items');
    const done = items && typeof items.onCartUpdate === 'function' ? items.onCartUpdate() : Promise.resolve();
    return Promise.resolve(done).then(() =>
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '?section_id=cart-icon-bubble')
        .then((r) => r.text())
        .then((html) => {
          const bubble = document.getElementById('cart-icon-bubble');
          const src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (bubble && src) bubble.innerHTML = src.innerHTML;
        })
    ).catch((e) => console.error(e));
  }
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const post = (path, body) => fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then((r) => { if (!r.ok) throw new Error('cart ' + r.status); });

  const fmt = (c) => new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100);
  function bumpTotal(delta) {
    document.querySelectorAll('[data-vv-now], [data-vv-was]').forEach((el) => {
      const key = el.hasAttribute('data-vv-now') ? 'vvNow' : 'vvWas';
      const v = (parseInt(el.dataset[key], 10) || 0) + delta;
      el.dataset[key] = v;
      el.textContent = fmt(v);
    });
  }

  document.addEventListener('click', (e) => {
    /* Protection du colis : ajoutée en arrière-plan (ligne cachée dans le tiroir), total mis à jour tout de suite, sans recharger le tiroir. */
    const btn = e.target.closest && e.target.closest('[data-vv-protect]');
    if (btn && btn.getAttribute('aria-busy') !== 'true') {
      e.preventDefault();
      const on = btn.getAttribute('aria-checked') === 'true';
      const delta = (parseInt(btn.dataset.price, 10) || 0) * (on ? -1 : 1);
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-checked', on ? 'false' : 'true');
      bumpTotal(delta);
      const req = on
        ? post('cart/change.js', { id: btn.dataset.lineKey, quantity: 0 })
        : fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }) })
            .then((r) => { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
            .then((d) => { const it = d.items && d.items[0]; if (it) btn.dataset.lineKey = it.key; });
      req.then(() => btn.removeAttribute('aria-busy')).catch((err) => {
        console.error(err);
        bumpTotal(-delta);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        btn.removeAttribute('aria-busy');
      });
      return;
    }
    /* Produits à ajouter */
    const add = e.target.closest && e.target.closest('[data-vv-add]');
    if (add && add.getAttribute('aria-busy') !== 'true') {
      e.preventDefault();
      const row = add.closest('[data-vv-up]');
      const sel = row && row.querySelector('[data-vv-up-select]');
      const id = Number(sel ? sel.value : add.dataset.variant);
      add.setAttribute('aria-busy', 'true');
      post('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(refresh).catch((err) => {
        console.error(err);
        add.removeAttribute('aria-busy');
      });
    }
  });

  /* Changement de variante : met à jour le prix du bouton */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-vv-up-select]');
    if (!sel) return;
    const row = sel.closest('[data-vv-up]');
    const out = row && row.querySelector('[data-vv-up-price]');
    const opt = sel.options[sel.selectedIndex];
    if (out && opt) out.textContent = opt.dataset.price;
  });
})();
